document.addEventListener('DOMContentLoaded', function () {
  var mobileQuery = window.matchMedia('(max-width: 800px)');

  document.querySelectorAll('.nav').forEach(function (nav) {
    var toggle = nav.querySelector('.nav-toggle');
    var panel = nav.querySelector('.nav-links');
    if (!toggle || !panel) return;

    function closePanel() {
      panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.querySelectorAll('.nav-links-item.is-open').forEach(function (item) {
        item.classList.remove('is-open');
      });
    }

    toggle.addEventListener('click', function () {
      var willOpen = !panel.classList.contains('is-open');
      panel.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });

    panel.querySelectorAll('.nav-links-item.has-dropdown > a').forEach(function (parentLink) {
      parentLink.addEventListener('click', function (event) {
        if (!mobileQuery.matches) return;
        event.preventDefault();
        parentLink.closest('.nav-links-item').classList.toggle('is-open');
      });
    });

    panel.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        var item = link.closest('.nav-links-item');
        var isDropdownParentLink = item && item.classList.contains('has-dropdown') && link.parentElement === item;
        if (isDropdownParentLink && mobileQuery.matches) return;
        closePanel();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) {
        closePanel();
        toggle.focus();
      }
    });
  });

  // En-tête collant : ombre progressive une fois qu'on a défilé, pour se
  // détacher visuellement du contenu (remplace la ligne pâle fixe d'origine).
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var ticking = false;
    function updateHeaderState() {
      header.classList.toggle('is-scrolled', window.scrollY > 4);
      ticking = false;
    }
    updateHeaderState();
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderState);
        ticking = true;
      }
    }, { passive: true });
  }
});
